import { z } from 'zod';

import {
  CUSTOM_FIELD_LEVELS,
  CUSTOM_FIELD_TYPES,
  CUSTOM_FIELD_VISIBILITY,
} from '~/constants/customFields';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

export const zodCreateCustomFieldPayloadSchema = z
  .object({
    allowedUnits: z.array(z.string()).nullish(),
    defaultUnit: z.string().nullish(),
    displayName: z.string().min(1),
    hasOptions: z.boolean().prefault(false),
    helpText: z.string().nullish(),
    level: z.enum(CUSTOM_FIELD_LEVELS),
    name: z.string().min(1),
    public: z.boolean().prefault(false),
    required: z.boolean().prefault(false),
    sorting: z.int().nullish(),
    type: z.enum(CUSTOM_FIELD_TYPES).nullish(),
    usedBy: z.array(z.uuid()).nullish(),
    visibility: z.enum(CUSTOM_FIELD_VISIBILITY).nullish(),
  })

  .transform((data) => {
    if (data.hasOptions) {
      return {
        ...data,
        allowedUnits: null,
        defaultUnit: null,
      };
    }

    return data;
  })
  .transform((data) => withoutObjectKeysWhereValueIs(data, [null, undefined]))
  .transform((data) => ({
    ...data,

    defaultUnit: data.defaultUnit || null, // Send null for saving 'no default unit'
  }));
